(function(){
 function trustDividerOffsets(rects,rowLeft){
  if(rects.length!==3)return [];
  return [0,1].map(index=>({left:(rects[index].right+rects[index+1].left)/2-rowLeft,visible:rects[index+1].left-rects[index].right>=6}));
 }
 function alignTrust(root){root.querySelectorAll('#temp-2026-collection-header .right-breadcrumb .collection-header__trust-badges').forEach(row=>{
  if(row.dataset.bmTrustLayoutReady)return;row.dataset.bmTrustLayoutReady='true';
  let frame=0;
  const layout=()=>{
   frame=0;
   const badges=[...row.querySelectorAll(':scope > .trust-badge-item')].filter(el=>el.getBoundingClientRect().width>0);
   if(badges.length!==3){row.removeAttribute('data-bm-trust-count');row.removeAttribute('data-bm-trust-aligned');return;}
   row.dataset.bmTrustCount='3';
   const offsets=trustDividerOffsets(badges.map(el=>el.getBoundingClientRect()),row.getBoundingClientRect().left);
   offsets.forEach((offset,index)=>{
    const name='--bm-trust-divider-'+(index+1),value=offset.left+'px';
    if(row.style.getPropertyValue(name)!==value)row.style.setProperty(name,value);
    row.style.setProperty(name+'-opacity',offset.visible?'1':'0');
   });
   row.setAttribute('data-bm-trust-aligned','');
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(layout);};
  const resize=new ResizeObserver(schedule);resize.observe(row);
  [...row.querySelectorAll(':scope > .trust-badge-item')].forEach(el=>resize.observe(el));
  const observer=new MutationObserver(schedule);observer.observe(row,{subtree:true,childList:true,characterData:true});
  document.fonts?.ready.then(schedule);layout();
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(row)){resize.disconnect();observer.disconnect();cancelAnimationFrame(frame);}});
 });}
 function init(root){alignTrust(root);root.querySelectorAll('nav[data-bm-meta-combo]').forEach(nav=>{
  if(nav.dataset.bmMetaReady)return;nav.dataset.bmMetaReady='true';
  let scheduled=false;
  function format(){scheduled=false;nav.querySelectorAll('.custom-count').forEach(count=>{
   if(count.querySelector('[data-bm-meta-count]'))return;
   const original=count.textContent.trim(),match=original.match(/\(?([\d,.\s]+)\s+reviews?\)?/i);if(!match)return;
   const full=document.createElement('span');full.className='bm-meta-count-full';full.dataset.bmMetaCount='true';full.textContent=original;
   const compact=document.createElement('span');compact.className='bm-meta-count-compact';compact.setAttribute('aria-hidden','true');compact.textContent='('+match[1].trim()+')';
   count.replaceChildren(full,compact);
  });
  nav.querySelectorAll('.trust-badge-item.judgeme .custom-jdgm-summary').forEach(summary=>{
   if(summary.closest('.bm-rating-link'))return;
   const badge=summary.closest('.trust-badge-item'),star=badge.querySelector('svg'),link=document.createElement('a');
   link.className='bm-rating-link';link.href='/pages/reviews';
   const rating=summary.querySelector('.custom-rating')?.textContent.trim()||'';
   const countText=summary.querySelector('.bm-meta-count-full')?.textContent||summary.querySelector('.custom-count')?.textContent||'';
   const countMatch=countText.match(/[\d,.]+/);
   link.setAttribute('aria-label',rating+' out of 5; read '+(countMatch?countMatch[0]+' customer reviews':'customer reviews'));
   badge.insertBefore(link,star||summary);if(star)link.appendChild(star);link.appendChild(summary);
  });}
  const observer=new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(format)}});observer.observe(nav,{childList:true,subtree:true});format();
 })}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
